import { useMemo } from "react";
import { useCaComposition } from "@/hooks/queries/useCaComposition";
import { useServiceTrend } from "@/hooks/queries/useServiceTrend";

interface ServicesAnalyticsParams {
  from: string;
  to: string;
  basis: "accrual" | "cash";
}

export function useServicesAnalytics({ from, to, basis }: ServicesAnalyticsParams) {
  const params = useMemo(() => ({ from, to, basis }), [basis, from, to]);
  const { data: composition, isLoading: loadingComposition } = useCaComposition(params);
  const { data: trend = [] } = useServiceTrend(params);

  const topByVolume = useMemo(
    () => [...(composition?.buckets ?? [])].sort((a, b) => b.volume - a.volume)[0],
    [composition?.buckets],
  );
  const topByGain = useMemo(
    () => [...(composition?.buckets ?? [])].sort((a, b) => b.gain - a.gain)[0],
    [composition?.buckets],
  );

  return {
    composition,
    trend,
    loading: loadingComposition,
    topByVolume,
    topByGain,
  };
}
